
// import { PrimaryButton, SecondaryButton } from '@ttd/lingo';
import { Button } from 'antd';

const bucketSchema = {
    "title": "File Upload Instance Config",
    "type": "object",
    "properties": {
        "Bucket": {
            "type": "string"
        },
        "IsTtdProduction": {
            "type": "boolean"
        },
        "Project": {
            "type": "string"
        },
        "Region": {
            "type": "string",
            "enum": ["ap-southeast-1", "ap-southeast-2", "eu-west-2", "us-west-1", "us-west-2", "us-east-1", "us-east-2"],
        },
        "Folders": {
            "type": "array",
            "items": {
                "type": "object",
                "properties": {

                    "DisplayName": {
                        "type": "string"
                    },
                    "PathPrefix": {
                        "type": "string"
                    },
                    "OverwriteExistingFiles": {
                        "type": "boolean",
                        "default": true
                    },
                    "Users": {
                        "type": "array",
                        "items": {
                            "type": "object",
                            "properties": {
                                "Email": {
                                    "type": "string"
                                },
                                "Permission": {
                                    "type": "string",
                                    "enum": ["upload", "view", "full"],
                                    "default": "full"
                                },
                            },
                            "required": ["Email", "Permission"]
                        }
                    }
                },
                "required": ["PathPrefix", "Users"]
            },
        },
        "Admins": {
            "type": "array",
            "items": {
                "type": "string"
            }
        }
    },
    "required": ["Bucket", "Region", "Project", "Folders"]
};

const bucketUiSchema = {
    Bucket: {
        // 'ui:classNames': 'red_field',
    },
    IsTtdProduction: {
        "ui:title": "Is it TTD Production Account?",
        "ui:widget": "select",
    },
    Folders: {
        "ui:title": "Folders in your bucket",
        'ui:classNames': 'folders_title',
        'ui:options': {
            orderable: false,
        },
        items: {
            Users: {
                "ui:title": "Users in your bucket",
                items: {
                    'ui:classNames': 'users_list_row',
                    'ui:options': {
                        label: false,
                        orderable: false
                    },
                    Email: {
                        'ui:options': {
                            label: false,
                            orderable: false,
                            removeable: false
                        },
                    },
                    Permission: {
                        "ui:title": "Perms",
                        'ui:widget': 'hidden'
                    }
                }
            }
        }
    },
    Admins: {
        'ui:widget': 'hidden'
    }
};


const newBucketData = {
    "Bucket": "",
    "Project": "",
    "Region": "eu-west-2",
    "IsTtdProduction": false,
    "Folders": [
        {
            "DisplayName": "",
            "PathPrefix": "",
            "Users": [
                {
                    "Email": "",
                    "Permission": ""
                }
            ]
        }
    ],
    "Admins": []
}


function AddButton(props) {
    const { ...btnProps } = props;
    return (
        <Button {...btnProps} style={{width: "100px"}}>
            Add
        </Button>
    );
}


function RemoveButton(props) {
    const { ...btnProps } = props;
    return (
        <Button {...btnProps} style={{width: "100px"}} >
            Remove
        </Button>
    );
}

function SubmitButton(props) {
    const { ...btnProps } = props;
    return (
        <Button {...btnProps} style={{width: "100px"}} type="primary" onClick={btnProps.onClick}>
            Save Bucket
        </Button>
    );
}


function CustomSubmitButton(props) {
    const { ...btnProps } = props;
  return (
    <Button
      type="primary"
      className="my-custom-submit" // Add your custom class here
      onClick={btnProps.onClick}
    >
      Submit
    </Button>
  );
};


export { bucketSchema, bucketUiSchema, newBucketData, AddButton, RemoveButton, SubmitButton, CustomSubmitButton };